export const projects = [
  {
    name: "Medicine Tracker",
    repository: "https://github.com/gustavool1/medicine_tracker",
    description:
      "Medicine tracker é um projeto android criado para ajudar os usuários a manterem controle dos remédios que precisam ingerir no seu dia-a-dia através de alarmes.",
    technology: "Flutter, Bloc, Dart, Nest, Node, Jest",
    hasApplication: false,
  },
  {
    name: "Do-it",
    aplicationLink: "https://do-it-sigma.vercel.app/dashboard",
    repository: "https://github.com/gustavool1/do-it",
    description:
      "Uma aplicação feita ajudar os usuários a criar e gerir seus hábitos.",
    technology: "React, TypeScript, Context-API, Chakra-UI, Consumo de API ",
    hasApplication: true,
  },
  {
    name: "BuildBox-Challenge",
    aplicationLink:
      "https://buildbox-challenge-gustavool1-gustavool1.vercel.app/",
    repository: "https://github.com/gustavool1/build-box",
    description:
      "Esta aplicação foi uma desafio técnico que me foi entregue para uma vaga. Ela é uma aplicação onde o usuário pode colocar seus posts, podendo colocar uma foto e descrição. Principal desafio deste projeto foi aprender a trabalhar com o FileReader.",
    technology:
      "React, TypeScript, Context-API, localStorage, Styled-components",
    hasApplication: true,
  },
  {
    name: "Burguer Kenzie",
    aplicationLink: "hamburgueria-xi.vercel.app",
    repository: "https://github.com/gustavool1/hamburgueria-ts-react",
    description:
      "Está aplicação foi feita em 2021 durante meu bootcamp na Kenzie Academy, o intuito dela é basicamente ser um menu online de uma hamburgueria.",
    technology:
      "React, TypeScript, Context-API, localStorage, Styled-components",
    hasApplication: false,
  },
];
